import React, { useState } from 'react';
import { 
  FaCar, 
  FaTrain, 
  FaPlane, 
  FaCalendarDay, 
  FaStar,
  FaChevronRight,
  FaChevronDown,
  FaUserFriends,
  FaRupeeSign,
  FaQuoteLeft,
  FaQuoteRight,
  FaGlobeAsia,
  FaMapMarkedAlt,
  FaHeadset
} from 'react-icons/fa';
import '../style.css';

const PindDaan = () => {
  const [expandedCards, setExpandedCards] = useState({});

  const toggleCard = (id) => {
    setExpandedCards(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const taxiServices = [
    {
      id: 1,
      name: "26 Seater Tempo Traveller",
      icon: <FaUserFriends />,
      stationPickup: 2600,
      airportPickup: 3200,
      ratePerKm: 32,
      fullDayRate: "₹32/km (250 KM minimum)",
      details: "Perfect for large groups, family tours, and corporate outings with spacious seating.",
      features: ["26 Seats", "AC", "Luggage Space", "Comfort"]
    },
    {
      id: 2,
      name: "Force Urbania",
      icon: <FaCar />,
      stationPickup: 2800,
      airportPickup: 3500,
      ratePerKm: 35,
      fullDayRate: "₹35/km (250 KM minimum)",
      details: "Luxury travel experience with premium interiors and entertainment system.",
      features: ["Premium", "Entertainment", "VIP", "Comfort"]
    },
    {
      id: 3,
      name: "Tempo Traveller 16 Seater",
      icon: <FaUserFriends />,
      stationPickup: 2000,
      airportPickup: 2500,
      ratePerKm: 24,
      fullDayRate: "₹24/km (250 KM minimum)",
      details: "Mid-size group transport solution with reliable service.",
      features: ["16 Seats", "Comfort", "Reliable", "Group"]
    },
    {
      id: 4,
      name: "Innova Crysta",
      icon: <FaCar />,
      stationPickup: 1000,
      airportPickup: 1800,
      ratePerKm: 18,
      fullDayRate: "₹18/km (250 KM minimum)",
      details: "Premium SUV perfect for family trips and business travel.",
      features: ["SUV", "Luxury", "Family", "Business"]
    },
    {
      id: 5,
      name: "Maruti Artiga",
      icon: <FaCar />,
      stationPickup: 900,
      airportPickup: 1400,
      ratePerKm: 14,
      fullDayRate: "₹14/km (250 KM minimum)",
      details: "Economical MPV with excellent fuel efficiency for family trips.",
      features: ["MPV", "Economical", "Fuel Efficient", "Family"]
    },
    {
      id: 6,
      name: "Swift Dzire",
      icon: <FaCar />,
      stationPickup: 700,
      airportPickup: 1000,
      ratePerKm: 12,
      fullDayRate: "₹12/km (250 KM minimum)",
      details: "Compact sedan perfect for city travel and airport transfers.",
      features: ["Sedan", "Compact", "City", "Economical"]
    }
  ];

  return (
    <div className="travel-main-container">
      {/* Hero Introduction */}
      <div className="travel-hero-section">
        <div className="travel-hero-content">
          <div className="travel-hero-text">
            <h1 className="travel-brand-title">
              <span className="travel-brand-highlight">Shree Balaji Travel</span>
            </h1>
            <p className="travel-hero-description">
              Are you ready to embark on the adventure of a lifetime? Whether you're dreaming of 
              relaxing on a tropical beach, discovering ancient ruins, or experiencing vibrant 
              city life, we are here to make your travel dreams come true. Our website offers 
              a wide range of tours and travel packages to help you explore the world with 
              ease and excitement.
            </p>
            <div className="travel-hero-features">
              <div className="travel-feature-item">
                <FaGlobeAsia className="travel-feature-icon" />
                <span>Worldwide Tours</span>
              </div>
              <div className="travel-feature-item">
                <FaMapMarkedAlt className="travel-feature-icon" />
                <span>Custom Packages</span>
              </div>
              <div className="travel-feature-item">
                <FaHeadset className="travel-feature-icon" />
                <span>24/7 Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Taxi Services Section */}
      <div className="travel-services-section">
        <div className="travel-section-header">
          <h2 className="travel-section-title">
            Taxi Service <span className="travel-title-highlight">In Varanasi</span>
          </h2>
          <p className="travel-section-subtitle">
            Premium taxi services for comfortable and reliable travel
          </p>
        </div>

        <div className="travel-cards-grid">
          {taxiServices.map((service) => (
            <div 
              key={service.id} 
              className={`travel-service-card ${expandedCards[service.id] ? 'travel-card-expanded' : ''}`}
            >
              <div className="travel-card-header">
                <div className="travel-card-icon">
                  {service.icon}
                </div>
                <h3 className="travel-card-title">{service.name}</h3>
                <button 
                  className="travel-read-more-btn"
                  onClick={() => toggleCard(service.id)}
                >
                  {expandedCards[service.id] ? (
                    <>
                      <FaChevronDown /> Show Less
                    </>
                  ) : (
                    <>
                      <FaChevronRight /> Read More....
                    </>
                  )}
                </button>
              </div>

              <div className="travel-price-grid">
                <div className="travel-price-item">
                  <div className="travel-price-icon">
                    <FaTrain />
                  </div>
                  <div className="travel-price-info">
                    <span className="travel-price-label">Railway Station Pick/Drop</span>
                    <span className="travel-price-amount">₹{service.stationPickup}</span>
                  </div>
                </div>
                
                <div className="travel-price-item">
                  <div className="travel-price-icon">
                    <FaPlane />
                  </div>
                  <div className="travel-price-info">
                    <span className="travel-price-label">Airport Pick-up/Drop</span>
                    <span className="travel-price-amount">₹{service.airportPickup}</span>
                  </div>
                </div>
                
                <div className="travel-price-item">
                  <div className="travel-price-icon">
                    <FaRupeeSign />
                  </div>
                  <div className="travel-price-info">
                    <span className="travel-price-label">Rate Per KM</span>
                    <span className="travel-price-amount">₹{service.ratePerKm}/km</span>
                  </div>
                </div>
                
                <div className="travel-price-item">
                  <div className="travel-price-icon">
                    <FaCalendarDay />
                  </div>
                  <div className="travel-price-info">
                    <span className="travel-price-label">Full Day (250 KM minimum)</span>
                    <span className="travel-price-amount">{service.fullDayRate}</span>
                  </div>
                </div>
              </div>

              {expandedCards[service.id] && (
                <div className="travel-card-details">
                  <div className="travel-features-list">
                    {service.features.map((feature, index) => (
                      <span key={index} className="travel-feature-tag">{feature}</span>
                    ))}
                  </div>
                  <p className="travel-card-description">{service.details}</p>
                  <button className="travel-book-btn">
                    <FaCar /> Book Now
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="travel-view-all-container">
          <button className="travel-view-all-btn">
            View all Taxi Services <FaChevronRight />
          </button>
        </div>
      </div>

      {/* Client Review Section */}
      <div className="travel-review-section">
        <div className="travel-section-header">
          <h2 className="travel-section-title">
            <FaStar className="travel-star-icon" /> Client Review
          </h2>
          <p className="travel-section-subtitle">
            What our customers say about us
          </p>
        </div>

        <div className="travel-review-card">
          <div className="travel-review-header">
            <div className="travel-reviewer-info">
              <div className="travel-reviewer-avatar">
                MD
              </div>
              <div>
                <h4 className="travel-reviewer-name">Mani Dubey</h4>
                <div className="travel-review-stars">
                  <FaStar />
                  <FaStar />
                  <FaStar />
                  <FaStar />
                  <FaStar />
                </div>
              </div>
            </div>
          </div>
          
          <div className="travel-review-content">
            <FaQuoteLeft className="travel-quote-icon travel-quote-left" />
            <p className="travel-review-text">
              Shree Balaji Travel ki service bhut hi perfect hai. On-call support behtareen tha — 
              especially Prama ji ka special thanks, unhone har step par bahut help ki. Highly recommended!
            </p>
            <FaQuoteRight className="travel-quote-icon travel-quote-right" />
          </div>
          
          <div className="travel-review-footer">
            <span className="travel-review-tag">Verified Customer</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PindDaan;